import React from "react";
import { Link } from "react-router-dom";
import { howItWorks, galleryImages } from "../mock";
import { ArrowRight } from "lucide-react";

const HowItWorks = () => (
  <>
    <section className="section bg-cream-100">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 text-center">
        <p className="tracking-widest text-coral-300 text-xs font-semibold uppercase">How It Works</p>
        <h1 className="font-serif text-navy-700 text-5xl md:text-6xl mt-4 leading-tight">Set up in <span className="italic">2 minutes</span>.<br />Collect memories <span className="italic">forever</span>.</h1>
        <p className="mt-6 text-navy-700/75 text-lg max-w-2xl mx-auto">From your private QR code to your downloadable gallery — here&apos;s exactly how GALERIECOP works.</p>
      </div>
    </section>

    <section className="pb-20 bg-cream-100">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 space-y-16">
        {howItWorks.map((s, i) => (
          <div key={s.step} className={`grid md:grid-cols-2 gap-10 items-center ${i % 2 ? "md:[&>div:first-child]:order-2" : ""}`}>
            <div>
              <div className="text-coral-300 font-serif text-7xl leading-none">{s.step}</div>
              <h2 className="font-serif text-navy-700 text-3xl md:text-4xl mt-3"><span className="italic">{s.title}</span></h2>
              <p className="mt-4 text-navy-700/75 text-lg max-w-xl leading-relaxed">{s.description}</p>
            </div>
            <div className="aspect-[4/3] rounded-3xl overflow-hidden soft-shadow">
              <img src={galleryImages[(i * 2) % galleryImages.length]} alt={s.title} className="w-full h-full object-cover" />
            </div>
          </div>
        ))}
      </div>
    </section>

    <section className="section bg-cream-200/60">
      <div className="max-w-3xl mx-auto px-5 lg:px-10 text-center">
        <h2 className="font-serif text-navy-700 text-4xl md:text-5xl">Ready to start <span className="italic">collecting?</span></h2>
        <p className="mt-5 text-navy-700/75 text-lg">Create your private gallery in under 2 minutes. No credit card required.</p>
        <Link to="/get-started" className="mt-7 inline-flex items-center gap-2 bg-coral-300 text-white px-8 py-4 rounded-full font-semibold hover:bg-coral-400 transition-colors soft-shadow-coral">
          Get Started Free <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  </>
);

export default HowItWorks;
